// orgLogo — deterministic placeholder styling for organisations without an
// uploaded logo (#40). The same org name always maps to the same color, so an
// org is recognisable at a glance across the app even before anyone uploads a
// real logo. Frontend-only; no backend field involved.

// Simple, stable string hash (djb2-ish). Deterministic across sessions/devices.
function hashString(s: string): number {
    let h = 5381;
    for (let i = 0; i < s.length; i++) {
        h = (h * 33) ^ s.charCodeAt(i);
    }
    return h >>> 0; // unsigned
}

// A soft pastel tile derived from the org name: a light tinted background with a
// darker, same-hue foreground for the initials — matching the app's light-sage
// chip look rather than a loud saturated block. HSL keeps the whole hue wheel
// available while lightness stays in a gentle, consistent band.
export function orgPlaceholderColor(name: string): { bg: string; fg: string } {
    const hue = hashString(name || '?') % 360;
    return {
        bg: `hsl(${hue}, 42%, 90%)`,
        fg: `hsl(${hue}, 48%, 34%)`,
    };
}

// 1–2 letter initials from the org name. Takes the first letter of the first two
// significant words ("Stockholms Kommun" → "SK"), or the first two letters of a
// single word ("Nexilink" → "NE").
export function orgInitials(name?: string): string {
    const words = (name ?? '').trim().split(/\s+/).filter(Boolean);
    if (words.length === 0) return '?';
    if (words.length === 1) return words[0].slice(0, 2).toUpperCase();
    return (words[0][0] + words[1][0]).toUpperCase();
}
